/**
 * NFT specific events.
 */

export enum NFTEventName {
  NFT_ACTIVITY_SELECTED = 'NFT Activity Selected',
  NFT_BUY_ADDED = 'NFT Buy Bag Added',
  NFT_BUY_BAG_CHANGED = 'NFT Buy Bag Changed',
  NFT_BUY_BAG_PAY = 'NFT Buy Bag Pay Clicked',
  NFT_BUY_BAG_REFUNDED = 'NFT Buy Bag Refunded',
  NFT_BUY_BAG_SIGNED = 'NFT Buy Bag Signed',
  NFT_BUY_BAG_SUCCEEDED = 'NFT Buy Bag Succeeded',
  NFT_BUY_TOKEN_SELECTED = 'NFT Token Selected',
  NFT_BUY_TOKEN_SELECTOR_CLICKED = 'NFT Token Selector Clicked',
  NFT_FILTER_OPENED = 'NFT Collection Filter Opened',
  NFT_FILTER_SELECTED = 'NFT Filter Selected',
  NFT_LISTING_COMPLETED = 'NFT Listing Success',
  NFT_LISTING_SIGNED = 'NFT Listing Signed',
  NFT_PROFILE_PAGE_START_SELL = 'NFT Profile Page Start Sell',
  NFT_SELL_ITEM_ADDED = 'NFT Sell Item Added',
  NFT_SELL_START_LISTING = 'NFT List Page Start Listing',
  NFT_TRENDING_ROW_SELECTED = 'Trending Row Selected',
}
